import { render } from "./BuydownCalculator.vue?vue&type=template&id=1afd0d42&scoped=true"
import script from "./BuydownCalculator.vue?vue&type=script&lang=js"
export * from "./BuydownCalculator.vue?vue&type=script&lang=js"

import "./BuydownCalculator.vue?vue&type=style&index=0&id=1afd0d42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afd0d42"]])

export default __exports__